import { ICON__columns3, ICON__rows3 } from '@/assets/icons_lucide';
import { UI_PRIMITIVE__icon_animated } from '@/components/ui/UI_PRIMITIVE__icon_animated';
import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { use_component_is_mounted_300 } from '@/hooks/is_mounted/use_component_is_mounted_300';
import { use_slice_generation, use_slice_grid2d, use_slice_ui } from '@/hooks/store/use_slices';
import { SVGComponent } from '@/types/types';
import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';
import { ENUM__field_connectable_type } from '@shared/dto/generation/graph_invoke/_fields/_base/_methods/ENUM__field_connectable_type';
import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';
import { DTO__grid2d } from '@shared/dto/grid2d/DTO__grid2d';
import { useMemo } from 'react';

interface PROPS {
  grid2d: DTO__grid2d;
}

export function GRID2D_BAR_generation_current_dimensions({ grid2d }: PROPS) {
  const { generation_current } = use_slice_generation(['generation_current']);
  const { grids2d_map } = use_slice_grid2d(['grids2d_map']);

  const { global__page_type } = use_slice_ui(['global__page_type']);

  /*
   *
   */

  const { graph } = generation_current.tool;

  const grid2d_chunk = useMemo(() => get_grid2d_chunk(), [generation_current, grids2d_map]);

  const { is_mounted } = use_component_is_mounted_300();

  /*
   * EFFECTS
   */

  function get_grid2d_chunk() {
    //wait for load grid from server
    if (!grids2d_map.has(generation_current._id)) return DTO__grid2d.CREATE_STUB();

    let out = grids2d_map.get_or_assert(generation_current._id);

    return out.clone();
  }

  /*
   * RENDERS
   */

  function render_grid2d_dimension(icon: SVGComponent, field: FIELD__base, amount: number) {
    if (amount == 1) return null;

    let { invocation_grid2d_view } = graph;

    if (field.meta.field_id == invocation_grid2d_view.stub_grid2d_column.meta.field_id) return null;
    if (field.meta.field_id == invocation_grid2d_view.stub_grid2d_row.meta.field_id) return null;

    let is_grid2d_mode = field.field_connectable__type() == ENUM__field_connectable_type.GRID2D_MODE;

    return (
      <span className="flex-center-vertical flex w-full gap-1 text-xs">
        <UI_PRIMITIVE__icon_animated className="!size-2.5" Icon={icon} />
        <span className="flex-1 text-left">{field.meta.sort_criteria}</span>
        {!is_grid2d_mode && <span className="text-right"> x {amount}</span>}
      </span>
    );
  }

  /*
   * HTML
   */
  if (generation_current.is_stub()) return <></>;
  if (grid2d_chunk.is_stub()) return <></>;
  if (global__page_type != ENUM__page_type.GENERATION) return <></>;
  if (grid2d.entity_type != ENUM__workspace_entity.ENTITY_GENERATION) return <></>;

  let grid2d_row = graph.grid2d__get_field_row();
  let grid2d_column = graph.grid2d__get_field_column();

  let [values_rows, values_columns] = graph.grid2d__get_values();

  return (
    <div
      className={` flex-center-vertical items-start flex-col px-2    
        text-bar-foreground
        bg-bar rounded-lg
        border border-component-border 
        hover:opacity-0
         ${is_mounted ? 'opacity-100 scale-100' : 'opacity-0 scale-50'}`}
    >
      {render_grid2d_dimension(ICON__columns3, grid2d_column, values_columns.length)}
      {render_grid2d_dimension(ICON__rows3, grid2d_row, values_rows.length)}
    </div>
  );
}
